import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import store from "@/store/"
import BookCardAudio from "@/shared/book-card/book-card-audio"
import events from "@/bl-events"
import handleCapturedVueError from "@/utils/handle-captured-vue-error"

Vue.use(VueI18n)

const initializeBookCardAudio = () => {
  const samples = document.querySelectorAll(".book-card__audio-instance")

  for (let i = 0; i < samples.length; i++) {
    const el = samples[i]
    const label = el.dataset.cardPlayerLabel
    const slug = el.dataset.cardSlug

    const instance = new Vue({
      name: "BookCardAudioInit",
      el,
      store,
      i18n: new VueI18n({ locale: getLocale() }),

      components: { BookCardAudio },

      data: {
        label,
        slug,
        onPlay: function () {
          events.emit("pause:all", instance)
        }
      },

      methods: {
        play() {
          this.$refs.audio.play()
        },

        pause() {
          this.$refs.audio.pause()
        }
      },

      template: `
        <book-card-audio
          :label="label"
          :play="play"
          :on-play="onPlay"
          :book-slug="slug"
          ref="audio" />
      `,
      errorCaptured: handleCapturedVueError
    })

    events.on("pause:all", (current) => {
      if (instance !== current) {
        instance.$refs.audio.pause()
      }
    })
  }
}

initializeBookCardAudio()

export default initializeBookCardAudio
